module.exports = __webpack_public_path__ + "img/appstore_en.2928664f.svg";